export const PERSIST_PROCESS_STATEMENT_QUESTIONS_SUCCESS = 'PERSIST_PROCESS_STATEMENT_QUESTIONS_SUCCESS';

export const persistProcessStatementQuestionsSuccess = ({ questions }) => ({
    type: PERSIST_PROCESS_STATEMENT_QUESTIONS_SUCCESS,
    payload: {
        questions,
    },
});
